import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { getRequest } from "../../axios";
import { useParams } from "react-router-dom";
import { authUserData } from "../../utils/Helper";
import DiameterWiseViewVendorBidRFQ from "./DiameterWiseViewVendorBidRFQ";
import CommonViewVendorBidRFQ from "./CommonViewVendorBidRFQ";

const ViewNewVendorBidRFQ = () => {
  const { id } = useParams();
      const location = useLocation();
      const queryParams = new URLSearchParams(location.search);
      const vendorIdd = queryParams.get('vendor_id');
  const VendorId = authUserData()?.vendor ? authUserData()?.vendor : null;
  const [apiLoading, setapiLoading] = useState(false);
  const vendorBidId = id ? atob(id) : null;

  const [tableData, setTableData] = useState([]);

  const [isDiameterWise, setIsDiameterWise] = useState(true);


  useEffect(() => {
    const getVendorBidRFQ = async () => {
      setapiLoading(true);
      try {
        const response1 = await getRequest(
          `bid-rfq/${id}/get-bid-rfq-city-wise/?vendor_id=${vendorIdd}`
        );
        const abc = response1.data.data;

        setIsDiameterWise(abc.is_diameter_wise)
      } catch (error) {
        console.error("Error:", error);
        setapiLoading(false);
      } finally {
        setapiLoading(false);
      }
    };
    getVendorBidRFQ();
  }, [vendorBidId]);


  if(isDiameterWise){
  return (
   <DiameterWiseViewVendorBidRFQ />
  );
  } else {
  return (
   <CommonViewVendorBidRFQ />
  );
  }


};

export default ViewNewVendorBidRFQ;
